/* Start Search */
function replacePopularSearchHeading() {
  const strong = document.querySelector("#klevu-pt-hover-box strong");
  if (strong) {
    const h2 = document.createElement("h2");
    h2.textContent = strong.textContent;
    h2.className = "section-title";
    strong.replaceWith(h2);
    return true;
  }
  return false;
}

function observeKlevuHeading() {
  const observer = new MutationObserver(() => {
    if (replacePopularSearchHeading()) {
      observer.disconnect(); // Stop the observer once applied
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function observeSearchPopup() {
  const applyAccessibilityAndFocus = () => {
    const searchPopup = document.querySelector('.site-header__search-container.is-active');
    const klevuBox = document.getElementById('klevu-pt-hover-box');

    if (searchPopup) {
      searchPopup.setAttribute('role', 'dialog');
      searchPopup.setAttribute('aria-label', 'Search');
      searchPopup.setAttribute('aria-modal', 'true');
      searchPopup.setAttribute('tabindex', '-1');

      // Intenta reemplazar <strong> por <h2>
      replacePopularSearchHeading();

      // Espera breve para que Klevu renderice <h2>
      setTimeout(() => {
        const heading = document.querySelector('#klevu-pt-hover-box h2');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus();
        }
      }, 150); 

      /* console.log("✅ Search popup accessibility and Klevu heading focus applied"); */
      return true;
    }
    return false;
  };

  if (applyAccessibilityAndFocus()) return;

  const observer = new MutationObserver(() => {
    if (applyAccessibilityAndFocus()) {
      observer.disconnect(); // Aplicado una vez
    }
  });

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });

}


function trapFocusKlevuToCloseButton() {
  const keywordsContainer = document.querySelector('.klevu-pt-rs-keywords');
  const closeButton = document.querySelector('.js-search-header-close');
  const cartButton = document.querySelector('.js-drawer-open-cart');
  const searchContainer = document.querySelector('.site-header__search-container');

  if (!keywordsContainer || !closeButton || !cartButton || !searchContainer) return;

  const focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]';
  const focusables = keywordsContainer.querySelectorAll(focusableSelectors);
  const lastFocusable = focusables[focusables.length - 1];

  if (!lastFocusable) return;

  lastFocusable.addEventListener('keydown', (e) => {
    if (e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault();
      closeButton.focus();
    }
  });

  closeButton.addEventListener('click', () => {
    setTimeout(() => {
      const searchFocusables = searchContainer.querySelectorAll(focusableSelectors);
      searchFocusables.forEach(el => {
        el.setAttribute('tabindex', '-1');
      });

      
      cartButton.focus();
    }, 300);
  });
}

/* Start Search result */
function applyAccessibilityToViewButtons() {
  const gridBtn = document.getElementById('gridViewBtn');
  const listBtn = document.getElementById('listViewBtn');

  if (!gridBtn || !listBtn) return;

  const isGridActive = gridBtn.classList.contains('kuCurrent');
  const isListActive = listBtn.classList.contains('kuCurrent');

  gridBtn.setAttribute('aria-label', isGridActive ? 'grid-view - Selected' : 'grid-view');
  listBtn.setAttribute('aria-label', isListActive ? 'list-view - Selected' : 'list-view');
}

function initializeViewButtonsAccessibility() {
  const gridBtn = document.getElementById('gridViewBtn');
  const listBtn = document.getElementById('listViewBtn');

  if (!gridBtn || !listBtn) return;
  setTimeout(() => {
    applyAccessibilityToViewButtons();
  }, 1000);  
  
  gridBtn.addEventListener('click', () => {
    setTimeout(applyAccessibilityToViewButtons, 0);
  });

  listBtn.addEventListener('click', () => {
    setTimeout(applyAccessibilityToViewButtons, 0);
  });

}

/* Start Cookie */
function fixCookieConsentAccessibility() {
   const runFix = () => {
    const banner = document.getElementById('pandectes-banner');
    if (!banner) return;

    const acceptBtn = banner.querySelector('.cc-btn-decision.cc-allow');
    const settingsBtn = banner.querySelector('.cc-settings');
    const dismissBtn = banner.querySelector('.cc-close');

    if (acceptBtn) acceptBtn.removeAttribute('aria-label');
    if (settingsBtn) settingsBtn.removeAttribute('aria-label');
    if (dismissBtn) dismissBtn.removeAttribute('aria-label');
  };

  const observer = new MutationObserver(() => {
    const banner = document.getElementById('pandectes-banner');
    if (banner && banner.querySelector('.cc-btn-decision.cc-allow')) {
      runFix();
      observer.disconnect(); 
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

/* Start CartDrawer */
function keepFocusOnCartQtyButton() {
  document.querySelectorAll('.js-qty__adjust').forEach(button => {
    button.addEventListener('click', (e) => {
      const clicked = e.currentTarget;
      const cartItem = clicked.closest('.cart__item');
      const key = cartItem?.getAttribute('data-key');
      const isPlus = clicked.classList.contains('js-qty__adjust--plus');
      const buttonClass = isPlus ? 'js-qty__adjust--plus' : 'js-qty__adjust--minus';

      if (!key) return;

      sessionStorage.setItem('focusCartKey', key);
      sessionStorage.setItem('focusCartButton', buttonClass);
    });
  });
}

function restoreCartFocus() {
  const key = sessionStorage.getItem('focusCartKey');
  const buttonClass = sessionStorage.getItem('focusCartButton');

  if (!key || !buttonClass) return;

  setTimeout(() => {
    const item = document.querySelector(`.cart__item[data-key="${key}"]`);
    const button = item?.querySelector(`.${buttonClass}`);
    if (button) button.focus();

    sessionStorage.removeItem('focusCartKey');
    sessionStorage.removeItem('focusCartButton');
  }, 50); 
}

function watchCartDrawerUpdates() {
  const target = document.querySelector('#CartDrawer .drawer__scrollable');
  if (!target) return;

  const observer = new MutationObserver(() => {
    keepFocusOnCartQtyButton();
    restoreCartFocus();        
  });

  observer.observe(target, {
    childList: true,
    subtree: true,
  });
}


/* End CartDrawer */

/* Start Home */
function makeCarouselDotsAccessible() {
  const pageDots = document.querySelectorAll(".flickity-page-dots .dot");

  pageDots.forEach((dot, index) => {
    dot.setAttribute("tabindex", "0");
    dot.setAttribute("role", "button");
    dot.setAttribute("aria-label", dot.getAttribute("aria-label") || `Go to slide ${index + 1}`);

    if (dot.classList.contains("is-selected")) {
      dot.setAttribute("aria-current", "step");
    } else {
      dot.removeAttribute("aria-current");
    }

    dot.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        dot.click();
      }
    });
  });
}
/* End Home */

/* Start Page Reviews */
function addSearchLabelForJudgeMe() {
  const reviewPage = document.getElementById('judgeme_all_reviews_page');

  if (!reviewPage) {
    console.log("⛔ Page is not Judge.me All Reviews Page.");
    return;
  }

  /* console.log("✅ Judge.me All Reviews Page detected."); */

  const container = document.querySelector('.jdgm-widget-actions-wrapper');
  const searchInput = container?.querySelector('.jdgm-review-search');

  if (container && searchInput && !document.getElementById('jdgm-accessible-search')) {
    /* console.log("➕ Adding wrapper and label to Judge.me search input"); */

    // Assign ID
    searchInput.id = 'jdgm-accessible-search';

    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'jdgm-search-wrapper';

    // Move input inside the wrapper
    wrapper.appendChild(searchInput);

    // Create label
    const label = document.createElement('label');
    label.setAttribute('for', 'jdgm-accessible-search');
    label.className = 'jdgm-search-label';
    label.textContent = 'Search reviews';

    // Insert label and wrapper into the container
    container.insertBefore(label, container.firstChild);
    container.insertBefore(wrapper, label.nextSibling);
  }
}

function addVisibleLabelToSortDropdown() {
  const select = document.querySelector('.jdgm-sort-dropdown');
  const arrow = document.querySelector('.jdgm-sort-dropdown-arrow');

  if (!select || !arrow) return;

  // Evitar duplicación si ya fue insertado
  const wrapper = select.closest('.jdgm-sort-dropdown-wrapper');
  if (!wrapper || wrapper.querySelector('label')) return;

  // Asegura que el select tenga un ID
  if (!select.id) select.id = 'sort-dropdown';

  // Crear y agregar el label
  const label = document.createElement('label');
  label.setAttribute('for', select.id);
  label.textContent = 'Sort by:';
  label.style.fontWeight = 'bold';
  label.style.display = 'block';
  label.style.marginBottom = '5px';

  const innerWrapper = document.createElement('div');
  innerWrapper.className = 'select-wrapper';

  innerWrapper.appendChild(select);
  innerWrapper.appendChild(arrow);

  wrapper.prepend(label);
  wrapper.appendChild(innerWrapper);
}

function updateReviewStarFiltersAriaLabels() {
  const rows = document.querySelectorAll('.jdgm-histogram__row');

  rows.forEach(row => {
    const starBtn = row.querySelector('.jdgm-histogram__star');
    if (!starBtn) return;

    const rating = row.getAttribute('data-rating');
    const frequency = row.getAttribute('data-frequency');
    const percentage = row.getAttribute('data-percentage');

    if (!rating || !frequency || !percentage) return;

    const baseLabel = `${percentage}% (${frequency}) reviews with ${rating} star rating`;

    if (row.classList.contains('jdgm-histogram__row--selected')) {
      starBtn.setAttribute('aria-label', `${baseLabel} - Selected`);
    } else {
      starBtn.setAttribute('aria-label', baseLabel);
    }
  });
}

/* End Page Reviews */

/* Product filters */
function applyCheckboxFocusIndicator() {
 const checkboxes = document.querySelectorAll('.tag__input');

  checkboxes.forEach(input => {
    input.addEventListener('focus', () => {
      const wrapper = input.closest('.tag__checkbox-wrapper');
      if (wrapper) wrapper.classList.add('is-focused');

      // Buscar el texto dentro del span.tag__text
      const tagText = wrapper.querySelector('.tag__text');
      if (tagText) {
        console.log('Focused on:', tagText.textContent.trim());
      }
    });

    input.addEventListener('blur', () => {
      const wrapper = input.closest('.tag__checkbox-wrapper');
      if (wrapper) wrapper.classList.remove('is-focused');
    });
  });
}

/* function trapFocusForLastFilterGroup() {
   const drawer = document.querySelector('#FilterDrawer.drawer--is-open');
  if (!drawer) return;

  const closeButton = drawer.querySelector('.drawer__close-button');
  if (!closeButton) return;

  const allGroups = Array.from(drawer.querySelectorAll('[class^="collection-sidebar__group--"]'));

  if (!allGroups.length) return;

  const lastGroup = allGroups[allGroups.length - 1];

  const toggleButton = lastGroup.querySelector('button[aria-controls]');
  const collapsible = lastGroup.querySelector('.collapsible-content--sidebar');
  const isOpen = toggleButton?.classList.contains('is-open');

  const tagInputs = lastGroup.querySelectorAll('.tag__input');

  drawer.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || e.shiftKey) return;

    if (isOpen && tagInputs.length > 0) {
      const lastInput = tagInputs[tagInputs.length - 1];
      if (document.activeElement === lastInput) {
        e.preventDefault();
        closeButton.focus();
      }
    } else if (!isOpen && document.activeElement === toggleButton) {
      e.preventDefault();
      closeButton.focus();
    }
  });

  setTimeout(() => {
    const firstInput = drawer.querySelector('.tag__input, button');
    if (firstInput) firstInput.focus();
  }, 100);
} */

/* function trapFocusForLastFilterGroup(drawerSelector = '#FilterDrawer') {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;

    const focusableSelectors = [
      'a[href]',
      'area[href]',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'button:not([disabled])',
      'iframe',
      'object',
      'embed',
      '[contenteditable]',
      '[tabindex]:not([tabindex="-1"])'
    ];

    const focusableElements = drawer.querySelectorAll(focusableSelectors.join(','));
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    function handleKeyDown(e) {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    }

    drawer.addEventListener('keydown', handleKeyDown);

    // Optional: focus the first element when the drawer opens
    setTimeout(() => firstElement?.focus(), 50);

    // Return a cleanup function if needed
    return () => {
      drawer.removeEventListener('keydown', handleKeyDown);
    };
} */

/* function trapFocusForLastFilterGroup(drawerSelector = '#FilterDrawer') {
    const drawer = document.querySelector('#FilterDrawer.drawer--is-open');
  if (!drawer) return;

  const closeButton = drawer.querySelector('.drawer__close-button');
  if (!closeButton) return;

  const groups = Array.from(drawer.querySelectorAll('[class^="collection-sidebar__group--"]'));
  if (!groups.length) return;

  const lastGroup = groups[groups.length - 1];
  const toggleBtn = lastGroup.querySelector('button[aria-controls]');
  if (!toggleBtn) return;

  drawer.addEventListener('keydown', (e) => {
    // Solo Tab hacia adelante
    if (e.key !== 'Tab' || e.shiftKey) return;

    const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true' || toggleBtn.classList.contains('is-open');

    // Si el grupo está cerrado y el foco está en el botón toggle
    if (!isExpanded && document.activeElement === toggleBtn) {
      e.preventDefault();
      closeButton.focus();
    }
  });
} */


/* End Product filters */

/* Product FAQS */
function fixAccordionAriaAttributes() {
  const triggers = document.querySelectorAll('#accordion .panel-title a');

  triggers.forEach(trigger => {
    if (trigger.getAttribute('aria-expanded') === 'true') {
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', (!expanded).toString());
    });
  });
}
/* End Product FAQS */

/* Product thumbnails */
function addAriaLabelsToProductButtons() {
  setTimeout(() => {
    const thumbArrows = document.querySelectorAll('button.product_thumb-arrow');

    if (thumbArrows.length) {
      thumbArrows.forEach((btn) => {
        if (!btn) return;
        const isPrev = btn.querySelector('.icon-chevron-left');
        btn.setAttribute('aria-label', isPrev ? 'Previous thumbnails' : 'Next thumbnails');
      });
    }

    const mainArrows = document.querySelectorAll('.product__thumb-arrow');
    if (mainArrows.length >= 2) {
      mainArrows[0].setAttribute('aria-label', 'Previous image');
      mainArrows[1].setAttribute('aria-label', 'Next image');
    }

    const zoomBtn = document.querySelector('button.product__photo-zoom');
    if (zoomBtn) {
      zoomBtn.setAttribute('aria-label', 'Zoom in on product image');
    }
  }, 1000);
}

/* End Product thumbnails */

/* Product Start */
function addAccessibleTextToStarRatings() {
  setTimeout(() => {
    const addText = () => {
      const badges = document.querySelectorAll('.product-block .jdgm-prev-badge__stars');
      badges.forEach(badge => {
        badge.removeAttribute('aria-label');
        if (badge.querySelector('.visually-hidden')) return;
  
        const score = badge.getAttribute('data-score') || '0';
        const hiddenText = document.createElement('span');
        hiddenText.className = 'visually-hidden';
        hiddenText.textContent = `${score} stars out of 5`;
        badge.appendChild(hiddenText);
      });
    };
  
    addText();
  
    const observer = new MutationObserver(() => {
      addText();
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }, 1000);
}

/* End Product Start */

/* Product tabs */
function convertStrongParagraphsToHeadings() {
  setTimeout(() => {
    const paragraphs = document.querySelectorAll('#parentHorizontalTab .resp-tab-content p');

    if (!paragraphs.length) return;
  
    paragraphs.forEach((p) => {
      const children = Array.from(p.childNodes).filter(node => {
        return !(node.nodeType === Node.COMMENT_NODE || (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()));
      });
  
      const hasOnlyStrong =
        children.length === 1 &&
        children[0].nodeType === Node.ELEMENT_NODE &&
        children[0].tagName === 'STRONG';
  
      if (hasOnlyStrong) {
        const h3 = document.createElement('h3');
        h3.appendChild(children[0].cloneNode(true)); // preserves the <strong>
        p.replaceWith(h3);
      }
    });
  }, 1000);
}
/* End Product tabs */

/* Product Lightbox */
function makeLightboxAccessible() {
  const lightbox = document.querySelector('.pswp'); 
  const closeButton = lightbox?.querySelector('.pswp__button--close');
  const dialogLabel = 'Enlarged view of the product'; 

  if (!lightbox) return;

  // Add ARIA attributes for accessibility
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.setAttribute('aria-label', dialogLabel);

 const focusableSelectors = `
    button:not([disabled]), 
    [href], 
    input:not([disabled]), 
    select:not([disabled]), 
    textarea:not([disabled]), 
    [tabindex]:not([tabindex="-1"])`;

  const trapFocus = (e) => {
    const focusable = lightbox.querySelectorAll(focusableSelectors);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  };

  const observer = new MutationObserver(() => {
    if (lightbox.classList.contains('pswp--open')) {
      const closeBtn = lightbox.querySelector('.pswp__button--close');
      document.addEventListener('keydown', trapFocus);

      
      if (closeBtn) closeBtn.focus();
    } else {
      
      document.removeEventListener('keydown', trapFocus);
      const heading = document.querySelector('h1.product-single__title');
      if (heading) heading.focus();
    }
  });

  const heading = document.querySelector('h1.product-single__title');
  if (heading && !heading.hasAttribute('tabindex')) {
    heading.setAttribute('tabindex', '-1');
  }

  observer.observe(lightbox, { attributes: true, attributeFilter: ['class'] });
}

/* End Product Lightbox */

/* Product Repairs */
function fixStateInputAccessibility() {
  const form = document.querySelector('#mc-embedded-subscribe-form');
  if (!form) return;

  const stateInput = form.querySelector('#mceADDRESS-state');
  const stateLabel = form.querySelector('label[for="mce-ADDRESS-state"]');

  if (stateInput && stateLabel) {
    stateInput.setAttribute('id', 'mce-ADDRESS-state');
  }
}
/* End Product Repairs */

function relocateHistogramSection(options = { show: true }) {
  const histogram = document.querySelector('.jdgm-histogram.jdgm-temp-hidden');
  const targetWrapper = document.querySelector('.jdgm-widget-actions-wrapper');

  if (histogram && targetWrapper && targetWrapper.parentNode) {
    
    targetWrapper.parentNode.insertBefore(histogram, targetWrapper);

    
    if (options.show) {
      histogram.classList.remove('jdgm-temp-hidden');
    }
  }
}

/* Register */
function focusOnAccessibilityStatusWhenReady() {
  const container = document.getElementById('accessibility-status');

  if (container && container.textContent.trim() !== '') {
    container.setAttribute('tabindex', '-1');
    container.focus();
    container.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

/* End Register */


function closeMobileSubmenusIfNavClosed() {
  const navDrawer = document.getElementById('NavDrawer');

  if (!navDrawer || navDrawer.classList.contains('drawer--is-open')) return;

  const openButtons = document.querySelectorAll('.mobile-nav__item button.is-open');

  openButtons.forEach(button => {
    if (button.hasAttribute('aria-open')) {
      const openValue = button.getAttribute('aria-open');
      button.removeAttribute('aria-open');
      button.setAttribute('aria-expanded', openValue);
    }

    button.click();
  });
}

function initAccessibleTabs() {

  const tabsContainer = document.querySelector('#parentHorizontalTab');
  if (!tabsContainer) return; 
  
  const tabList = tabsContainer.querySelector('.resp-tabs-list');
  const tabButtons = tabList.querySelectorAll('button');

  tabList.setAttribute('role', 'tablist');

  tabButtons.forEach((button, index) => {
    const panelId = `tabpanel-${index}`;
    const tabId = `tab-${index}`;

    button.setAttribute('role', 'tab');
    button.setAttribute('id', tabId);
    button.setAttribute('aria-controls', panelId);
    button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');

    const li = button.closest('li');
    if (li) li.removeAttribute('role'); // clean up incorrect `role="tab"` in <li>
  });

  const tabPanels = tabsContainer.querySelectorAll('[id^="hor_1_tab_item"]');

  tabPanels.forEach((panel, index) => {
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('id', `tabpanel-${index}`);
    panel.setAttribute('aria-labelledby', `tab-${index}`);
    panel.setAttribute('tabindex', '0');
  });
}

function addMissingIframeTitles(containerSelector = 'body', defaultTitle = 'Embedded video by WaterField Designs') {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const iframes = container.querySelectorAll('iframe, frame');

    iframes.forEach((el, index) => {
      const hasTitle = el.hasAttribute('title') && el.getAttribute('title').trim() !== '';
      if (!hasTitle) {
        el.setAttribute('title', `${defaultTitle} ${index + 1}`);
      }
    });
}

function assignAltFromSiblingText() {
    const blocks = document.querySelectorAll(".metafields_section .metafield_block");

    blocks.forEach((block, index) => {
      const image = block.querySelector(".image_column img");
      const content = block.querySelector(".content_column");

      if (image && (!image.hasAttribute("alt") || image.getAttribute("alt").trim() === "")) {
        if (content) {
          const textSource = content.querySelector("h1, h2, h3, h4, h5, h6, p");
          if (textSource) {
            const altText = textSource.textContent.trim().replace(/\s+/g, " ");
            if (altText.length > 0) {
              image.setAttribute("alt", altText);
              /* console.info(`✅ Alt assigned from content [#${index + 1}]:`, altText); */
            }
          }
        }
      }
    });
  }

function reportUnlabeledImages() {
  const allImages = document.querySelectorAll("img");
  allImages.forEach((img, i) => {
    const alt = img.getAttribute("alt");
    if (!alt || alt.trim() === "") {
      /* console.warn(`🚨 Unlabeled <img> found [#${i + 1}]:`, img); */
    }
  });
}

function assignAltFromImageFilename() {
  const images = document.querySelectorAll(".grid__item img");

  images.forEach((img, index) => {
    const alt = img.getAttribute("alt");
    const isEmptyAlt = alt === null || alt.trim() === "";

    if (isEmptyAlt && img.src) {
      try {
        const url = new URL(img.src);
        const filename = url.pathname.split("/").pop();
        const nameWithoutExt = filename.replace(/\.[^/.]+$/, ""); // remove .jpg
        const readableName = nameWithoutExt.replace(/[_-]+/g, " ").trim();
        if (readableName.length > 0) {
          img.setAttribute("alt", readableName);
          /* console.info(`🖼️ Alt assigned from archive name [#${index + 1}]:`, readableName); */
        }
      } catch (error) {
        /* console.warn("❌ Could not process src:", img.src); */
      }
    }
  });
}


function removeInvalidAriaLabelledby() {
  const elements = document.querySelectorAll('[aria-labelledby]');
  let removedCount = 0;

  elements.forEach(el => {
    const labelledby = el.getAttribute('aria-labelledby');
    if (!labelledby) return;

    const ids = labelledby.trim().split(/\s+/);
    const allExist = ids.every(id => document.getElementById(id));

    if (!allExist) {
      el.removeAttribute('aria-labelledby');
      removedCount++;
      /* console.warn(`🧹 aria-labelledby eliminado (ID no encontrado):`, el); */
    }
  });
  
}

function initVideoControlsInSlider() {
  const slides = document.querySelectorAll('.slideshow__slide');

  slides.forEach((slide) => {
    const video = slide.querySelector('video');

    if (video) {
      // Evita duplicar el botón
      if (!slide.querySelector('.video-toggle')) {
        const btn = document.createElement('button');
        btn.className = 'video-toggle';
        btn.textContent = '⏸';
        btn.setAttribute('aria-label', 'Pause video');

        const wrapper = slide.querySelector('.hero__image-wrapper');
        if (wrapper) wrapper.appendChild(btn);

        btn.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            btn.textContent = '⏸';
            btn.setAttribute('aria-label', 'Pause video');
          } else {
            video.pause();
            btn.textContent = '▶️';
            btn.setAttribute('aria-label', 'Play video');
          }
        });
      }
    }
  });

  // Show only the active slide button
  const updateButtonVisibility = () => {
    slides.forEach((slide) => {
      const btn = slide.querySelector('.video-toggle');
      if (btn) {
        btn.style.display = slide.classList.contains('is-selected') ? 'block' : 'none';
      }
    });
  };

  updateButtonVisibility(); // Inicial

  // Watch for changes in the slider to update visibility
  const flickitySlider = document.querySelector('.flickity-slider');
  if (flickitySlider) {
    const observer = new MutationObserver(updateButtonVisibility);
    observer.observe(flickitySlider, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class'],
    });
  }
}

function initVideoControlsOutsideSliders() {
  const videos = document.querySelectorAll('video');

  videos.forEach((video) => {
    // Skip videos that are inside sliders (already handled by initVideoControlsInSlider)
    if (video.closest('.slideshow__slide')) return;

    // Skip if a toggle button already exists
    if (video.parentElement.querySelector('.video-toggle')) return;

    // Create the toggle button
    const btn = document.createElement('button');
    btn.className = 'video-toggle';
    btn.textContent = '⏸';
    btn.setAttribute('aria-label', 'Pause video');

    // Style the button (accessible contrast and click area)
    btn.style.display = 'block';
    btn.style.position = 'absolute';
    btn.style.bottom = '10px';
    btn.style.right = '10px';
    btn.style.background = 'rgba(0,0,0,0.6)';
    btn.style.color = '#fff';
    btn.style.border = 'none';
    btn.style.borderRadius = '4px';
    btn.style.padding = '6px 10px';
    btn.style.cursor = 'pointer';
    btn.style.zIndex = '10';

    // Ensure the parent container has relative positioning so the button can be positioned absolutely
    const parent = video.parentElement;
    if (getComputedStyle(parent).position === 'static') {
      parent.style.position = 'relative';
    }
    parent.appendChild(btn);

    // Add click event to toggle play/pause
    btn.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        btn.textContent = '⏸';
        btn.setAttribute('aria-label', 'Pause video');
      } else {
        video.pause();
        btn.textContent = '▶️';
        btn.setAttribute('aria-label', 'Play video');
      }
    });
  });
}

// Run after the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  initVideoControlsOutsideSliders();
});


function addAriaLabelsToSelects() {
  const selects = document.querySelectorAll('select');
  let count = 0;

  selects.forEach(select => {
    const hasLabel = select.labels && select.labels.length > 0;
    const hasAriaLabel = select.hasAttribute('aria-label') || select.hasAttribute('aria-labelledby');
    const hasTitle = select.hasAttribute('title');

    if (!hasLabel && !hasAriaLabel && !hasTitle) {
      // Try to deduce an accessible name from the first visible option
      let placeholder = 'Select an option';
      const firstOption = select.querySelector('option');
      if (firstOption && firstOption.textContent.trim() !== '') {
        placeholder = firstOption.textContent.trim();
      }

      // Add a dynamic aria-label with the inferred placeholder
      select.setAttribute('aria-label', placeholder);
      count++;
    }
  });  
}

/* function fixLinksBehavingLikeButtons() {
  document.querySelectorAll('a').forEach((el) => {
    const hasHref = el.hasAttribute('href');
    const hrefValue = el.getAttribute('href');
    const role = el.getAttribute('role');
    const hasOnClick = el.hasAttribute('onclick');

    const behavesLikeButton = (
      (!hasHref || hrefValue === "" || hrefValue === "#") &&
      hasOnClick
    ) || (
      role === 'button' &&
      (!hasHref || hrefValue === "" || hrefValue === "#")
    );

    if (behavesLikeButton) {
      // Crear botón nuevo
      const btn = document.createElement('button');
      btn.innerHTML = el.innerHTML; // Copiar contenido visible
      btn.className = el.className; // Copiar clases CSS

      // Copiar atributos relevantes (data-*, title)
      Array.from(el.attributes).forEach(attr => {
        if (attr.name.startsWith('data-') || attr.name === 'title') {
          btn.setAttribute(attr.name, attr.value);
        }
      });

      // Transferir onclick si existe
      if (hasOnClick) {
        btn.setAttribute('onclick', el.getAttribute('onclick'));
      }

      // Reemplazar el <a> en el DOM por el <button>
      el.parentNode.replaceChild(btn, el);

      console.log('✅ Reemplazado <a> por <button> para accesibilidad:', btn);
    }
  });
} */

function fixLinksBehavingLikeButtons() {
  document.querySelectorAll('a').forEach((el) => {
    // Prevent touching Grid/List buttons
    if (el.id === 'gridViewBtn' || el.id === 'listViewBtn') return;

    const hasHref = el.hasAttribute('href');
    const hrefValue = el.getAttribute('href');
    const role = el.getAttribute('role');
    const hasOnClick = el.hasAttribute('onclick');

    const behavesLikeButton = (
      (!hasHref || hrefValue === "" || hrefValue === "#") && hasOnClick
    ) || (
      role === 'button' && (!hasHref || hrefValue === "" || hrefValue === "#")
    );

    if (behavesLikeButton) {
      const btn = document.createElement('button');
      btn.innerHTML = el.innerHTML;
      btn.className = el.className;

      // Copiar atributos relevantes
      Array.from(el.attributes).forEach(attr => {
        if (
          attr.name.startsWith('data-') ||
          attr.name === 'title'
        ) {
          btn.setAttribute(attr.name, attr.value);
        }
      });

      // Copiar aria-label si existe
      if (el.hasAttribute('aria-label')) {
        btn.setAttribute('aria-label', el.getAttribute('aria-label'));
      }

      // Transferir onclick si existe
      if (hasOnClick) {
        btn.setAttribute('onclick', el.getAttribute('onclick'));
      }

      el.parentNode.replaceChild(btn, el);
    }
  });
}



function detectDuplicateIds() {
  const allElements = document.querySelectorAll('[id]');
  const idMap = new Map();

  allElements.forEach(el => {
    const id = el.id;
    if (idMap.has(id)) {
      idMap.get(id).push(el);
    } else {
      idMap.set(id, [el]);
    }
  });

  let hasDuplicates = false;
  idMap.forEach((elements, id) => {
    if (elements.length > 1) {
      hasDuplicates = true;
      console.warn(`⚠️ Duplicate ID detected: "${id}" used ${elements.length} times`, elements);
    }
  });

  if (!hasDuplicates) {
    console.info('✅ No duplicate IDs found.');
  }
}

function checkLinksWithoutAccessibleName() {
  document.querySelectorAll('iframe').forEach((iframe) => {
    if (!iframe.hasAttribute('title')) {
      console.group('🚨 Iframe sin atributo title encontrado:');
      console.log('Elemento:', iframe);
      console.groupEnd();
    }
  });
  
  console.log('✅ Revisión de iframes finalizada.');
}

/* MENU */
function initAccessibleShopifyMenu() {
  const detailsItems = document.querySelectorAll('.site-nav__details');

  detailsItems.forEach(item => {
    let hasFocusedFirstLink = false; // Flag para evitar bucle

    item.addEventListener('focusin', (event) => {
      item.setAttribute('open', 'true');
      item.setAttribute('aria-expanded', 'true');

      // Solo enfocar el primer enlace si el foco viene desde fuera del <details>
      if (!hasFocusedFirstLink && !item.contains(event.relatedTarget)) {
        const firstLink = item.querySelector('.site-nav__dropdown-link');
        if (firstLink) {
          setTimeout(() => firstLink.focus(), 50);
          hasFocusedFirstLink = true;
        }
      }
    });

    item.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!item.contains(document.activeElement)) {
          item.removeAttribute('open');
          item.setAttribute('aria-expanded', 'false');
          hasFocusedFirstLink = false; // Reset flag cuando se cierre
        }
      }, 50);
    });
  });
}
/* MENU */

function fixAccessibilityForAllCollections() {
  const items = document.querySelectorAll('.grid__item');

  // Exit early if there are no matching elements
  if (!items.length) return;

  items.forEach(item => {
    const link = item.querySelector('a.collection-link');
    const heading = item.querySelector('h3');
    const img = link ? link.querySelector('img') : null;
    const secondaryLink = item.querySelector('.btn.btn--secondary');

    // 1. Move the H3 element inside the main link if it's not already there
    if (link && heading && !link.contains(heading)) {
      link.appendChild(heading);
    }

    // 2. If the link already has visible text, make the image decorative
    if (img && heading && link.contains(heading)) {
      img.setAttribute('alt', '');
    }

    // 3. Remove duplicate link if it points to the same destination as the main link
    if (link && secondaryLink && secondaryLink.href === link.href) {
      secondaryLink.remove();
    }
  });
}


document.addEventListener("DOMContentLoaded", () => {
    
  setTimeout(() => {
    checkLinksWithoutAccessibleName();

    removeInvalidAriaLabelledby();
    
    observeKlevuHeading();
    observeSearchPopup();
    applyCheckboxFocusIndicator();
    fixAccordionAriaAttributes();
    addAriaLabelsToProductButtons();
    addAccessibleTextToStarRatings();
    convertStrongParagraphsToHeadings();
    makeLightboxAccessible();
    fixCookieConsentAccessibility();
    fixStateInputAccessibility();
    keepFocusOnCartQtyButton();     
    watchCartDrawerUpdates();  
    focusOnAccessibilityStatusWhenReady();
    initializeViewButtonsAccessibility();
  
    closeMobileSubmenusIfNavClosed();
  
    addAriaLabelsToSelects();

    fixLinksBehavingLikeButtons();
    
    addSearchLabelForJudgeMe();
    addVisibleLabelToSortDropdown();
    
    
    makeCarouselDotsAccessible();
    trapFocusKlevuToCloseButton();
    relocateHistogramSection(); 
    initAccessibleTabs(); 
    addMissingIframeTitles(); 

    assignAltFromSiblingText();
    reportUnlabeledImages();
    assignAltFromImageFilename();
    
    initVideoControlsInSlider(); 
    initVideoControlsOutsideSliders(); 

    detectDuplicateIds();

    initAccessibleShopifyMenu();

    fixAccessibilityForAllCollections();
    
    updateReviewStarFiltersAriaLabels();
    trapFocusInFilterDrawer();
  }, 2000);


  document.querySelectorAll('.jdgm-histogram__row').forEach(row => {
    row.addEventListener('click', () => {
      document.querySelectorAll('.jdgm-histogram__row--selected')
        .forEach(el => el.classList.remove('jdgm-histogram__row--selected'));

      row.classList.add('jdgm-histogram__row--selected');
      updateReviewStarFiltersAriaLabels();
    });
  });

  /* document.querySelector('.js-drawer-open-filters')?.addEventListener('click', () => {
    setTimeout(() => trapFocusForLastFilterGroup(), 300); // 
  }); */
  
});

function trapFocusInFilterDrawer() {
  const drawer = document.querySelector('#FilterDrawer.drawer--is-open');
  if (!drawer) return;

  const allGroups = Array.from(drawer.querySelectorAll('[class^="collection-sidebar__group--"]'));
  if (!allGroups.length) return;

  const lastGroup = allGroups[allGroups.length - 1];
  const lastToggleBtn = lastGroup.querySelector('button.collapsible-trigger');
  const lastInputs = Array.from(lastGroup.querySelectorAll('.tag__input'));
  if (!lastInputs.length || !lastToggleBtn) return;

  const lastInput = lastInputs[lastInputs.length - 1];

  drawer.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || e.shiftKey) return;

    const isOpen =
      lastToggleBtn.classList.contains('is-open') ||
      lastToggleBtn.getAttribute('aria-expanded') === 'true';

    if (document.activeElement === lastInput && !isOpen) {
      e.preventDefault();
      lastToggleBtn.click();

      setTimeout(() => {
        lastInput.focus();
      }, 150);
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  const promoTexts = document.querySelectorAll('.promo-grid__text');

  promoTexts.forEach(function(textSection) {
    const btn = textSection.querySelector('a.btn');

    if (btn) {
      textSection.style.cursor = 'pointer';

      textSection.addEventListener('click', function(e) {
        if (e.target.tagName.toLowerCase() !== 'a') {
          window.location.href = btn.href;
        }
      });
    }
  });
});
